import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HomePageES = lazy(() => import('../pages/home-es/page'));
const HomePageJP = lazy(() => import('../pages/home-jp/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePageJP />,
  },
  {
    path: '/en',
    element: <HomePage />,
  },
  {
    path: '/es',
    element: <HomePageES />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
